import isString from "lodash/isString";
export default class FetchError extends Error {
  constructor(message, status, additional) {
    var _a, _b;
    super(message);
    this.name = "FetchError";
    const details = isString(additional) ? additional : (_a = additional == null ? void 0 : additional.message) != null ? _a : "Not available";
    this.details = details;
    this.message = `There was an error fetching a resource: ${message}. Additional information: ${details}`;
    this.responseMessage = (_b = additional == null ? void 0 : additional.message) != null ? _b : void 0;
    this.additional = { body: additional, status, res: { text: isString(additional) && additional } };
    this.status = status;
  }
}
